export const DEL_ER_MEDICATIONS_SUSP = "DEL_ER_MEDICATIONS_SUSP";
export const DEL_ER_RAM_CATEGORY = "DEL_ER_RAM_CATEGORY";
export const DEL_ER_MEDICATION_HISTORY = "DEL_ER_MEDICATION_HISTORY";
export const DEL_ER_WORK_FLOW = "DEL_ER_WORK_FLOW";
